import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Types for the slice
interface MnoOption {
  mno_id: string;
  mno_name: string;
}

interface SystemTransactionalPerformanceState {
  mnoOptions: MnoOption[];
  selectedMnos: string[];
  lastFetched: number | null;
}

const initialState: SystemTransactionalPerformanceState = {
  mnoOptions: [],
  selectedMnos: [],
  lastFetched: null,
};

const systemTransactionalPerformanceSlice = createSlice({
  name: 'systemTransactionalPerformance',
  initialState,
  reducers: {
    setMnoOptions: (state, action: PayloadAction<MnoOption[]>) => {
      // Only set MNO options if they haven't been set before or if explicitly clearing
      if (state.mnoOptions.length === 0) {
        state.mnoOptions = action.payload;
        state.lastFetched = Date.now();
      }
    },
    forceSetMnoOptions: (state, action: PayloadAction<MnoOption[]>) => {
      // Force set MNO options (for initial load)
      state.mnoOptions = action.payload;
      state.lastFetched = Date.now();
    },
    setSelectedMnos: (state, action: PayloadAction<string[]>) => {
      state.selectedMnos = action.payload;
    },
    clearMnoOptions: (state) => {
      state.mnoOptions = [];
      state.selectedMnos = [];
      state.lastFetched = null;
    },
  },
});

export const { setMnoOptions, forceSetMnoOptions, setSelectedMnos, clearMnoOptions } = systemTransactionalPerformanceSlice.actions;

// Selectors
export const selectMnoOptions = (state: { systemTransactionalPerformance: SystemTransactionalPerformanceState }) => 
  state.systemTransactionalPerformance.mnoOptions;

export const selectSelectedMnos = (state: { systemTransactionalPerformance: SystemTransactionalPerformanceState }) => 
  state.systemTransactionalPerformance.selectedMnos;

export const selectLastFetched = (state: { systemTransactionalPerformance: SystemTransactionalPerformanceState }) => 
  state.systemTransactionalPerformance.lastFetched;

export default systemTransactionalPerformanceSlice.reducer;
